import * as React from 'react';
import { SvgIcon } from 'telstra-ui/components/svg/Icon';
import './style.less';

interface IDeleteComponentProps {
    tid?: string;
    last4?: string;
    cardName?: string;
    cardIcon?: string;
    expiryMonth?: string;
    expireyYear?: string;
    onConfirmClick?: () => void;
}

export const DeletePaymentUIModelBody = (props: IDeleteComponentProps) => {
    const BodyContent = (
        <>
            <div className="delete-confirm-text">
            Are you sure you want to delete this payment method?
            </div>
            <div className='bank-account-card-details'> <SvgIcon className="bank-card-icon" name={props?.cardIcon} />
                <span className='bank-account-card text-bold'>{props?.cardName}</span>
            </div>
            <div className='before-last4-digit card-item text-light'><span className="card-code">••••</span>
                <span>&nbsp;&nbsp;{props?.last4}</span><span>{props?.expiryMonth}
                    {props?.expireyYear ? `/` + props?.expireyYear?.slice(-2) : ''}</span></div>
        </>
    );
    return BodyContent;
}

